import { Module } from '@nestjs/common'
import { RoomPlanController, TokenController } from './controllers'
import { TableCombinationService, TableGraphService, TableService } from './services'

@Module({
	controllers: [RoomPlanController, TokenController],
	providers: [TableService, TableCombinationService, TableGraphService],
})
export class RoomPlanModule {}
